import { createSelector } from 'reselect';
import { LANGUAGES } from '@app/i18n';

export const getLocale = ({ locale = {} }: $TSFixMe) => locale;

export const getGDPR = createSelector(getLocale, ({ isGDPR = true }) => isGDPR);

export const getCountryCode = createSelector(
  getLocale,
  ({ countryCode = null }) => countryCode,
);

export const getBrowserLanguage = createSelector(
  getLocale,
  ({ browserLanguage = 'en' }) => LANGUAGES[browserLanguage] || LANGUAGES.en,
);

export const getBrowserLanguageCode = createSelector(
  getLocale,
  ({ browserLanguage = 'en' }) => browserLanguage,
);
